module.exports = __webpack_public_path__ + "static/img/chanta (21).bcecb08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (21).jpg
// module id = xk++
// module chunks = 0